<div *ngIf="userReady == OrganisationLoadingStatus.Successful" class="login-dialog">

  <div class="modal-header d-flex justify-content-between">

    <h4 class="modal-title pull-left">Select organisation</h4>

    <div class="modal-title pull-right" container="body">{{ authService.getUserName() }} ({{authService.getUser()}})
    </div>


  </div>
  <div class="modal-body">

    <div class="login-box">
      <div class="dropdown">
        <button class="btn dropdown-toggle" style="border-color: #084298;" type="button" id="dropdownMenuButton"
          data-bs-toggle="dropdown" aria-expanded="false" (click)="searchBar.focus()">
          <span class="dropdown-text">{{ selectedItem?.label }}</span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li>
            <input #searchBar type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchText" />
          </li>
          <div *ngIf="filteredItems==0&&items.length>0" class="m-5">
            No organisations found!
          </div>
          <div *ngIf="items.length==0" class="m-5" style="height: calc(30vh); overflow-y: auto; overflow-x: hidden;">
            <p>No organisations assigned to user</p>
          </div>
          <div *ngIf="items.length>0" style="height: calc(30vh); overflow-y: auto; overflow-x: hidden;">
            <li *ngFor="let item of filteredItems" (click)="selectItem(item)">
              <a class="dropdown-item">{{ item.label }}</a>
            </li>
          </div>
        </ul>
      </div>
      <div class="d-flex justify-content-center">
        <button #selectOrganisation class="btn btn-light mt-2" *ngIf="isChecked" type="button"
          (click)="onSelectOrganisation()">Select</button>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div><input class="checkTermsOfUse" type="checkbox" [(ngModel)]="isChecked" [(disabled)]="isDisabled" /></div>
      <div>I have read and accepted the <a class="link-terms" style="cursor:pointer" (click)="showTermsOfUse();">Terms
          of use</a></div>
    </div>

  </div>
</div>
<app-loading *ngIf="userReady == OrganisationLoadingStatus.Not_started"></app-loading>
<div *ngIf="userReady == OrganisationLoadingStatus.Failed" >
  <div class="text-center" style="margin-top:10%">
    <div>An error occured when initializing application. Please refresh the page.</div>
    <div><button class="btn btn-light mt-2" type="button" (click)="onRefreshLogin()">Refresh</button></div>
  </div>
</div>